const user_data = sessionStorage.getItem("user_item");
const device_data = sessionStorage.getItem("device_item");


export const userConfig = {
    user: JSON.parse(user_data),
    device: JSON.parse(device_data)
}